export const minTotalProceduresCost = 2500;
